import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from '@abp/abpHttpInterceptor';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.FinancialSettingsServiceProxy,
        ApiServiceProxies.SurveyWorksServiceProxy,
        ApiServiceProxies.InvitationWorksServiceProxy,
        ApiServiceProxies.EvaluatorsServiceProxy,
        ApiServiceProxies.InstitutionWorksServiceProxy,
        ApiServiceProxies.WorksServiceProxy,
        ApiServiceProxies.SpecialitiesServiceProxy,
        ApiServiceProxies.EventWorksServiceProxy,
        ApiServiceProxies.SettingsServiceProxy,
        ApiServiceProxies.AdminActivitiesServiceProxy,
        ApiServiceProxies.SituationsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.AnnuitiesServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.JobPositionServiceProxy,
        ApiServiceProxies.InstitutionsServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.PaymentMethodsServiceProxy,
        ApiServiceProxies.ProtocolsServiceProxy,
        ApiServiceProxies.DocumentTypesServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.PaymentChargesServiceProxy,
        ApiServiceProxies.ItauPaymentServiceProxy,
        ApiServiceProxies.EventsServiceProxy,
        ApiServiceProxies.EventTypesServiceProxy,
        ApiServiceProxies.CouponsServiceProxy,
        ApiServiceProxies.CostCenterServiceProxy,
        ApiServiceProxies.RegistrationsServiceProxy,
        ApiServiceProxies.MemberAnnuityServiceProxy,
        ApiServiceProxies.CnabsServiceProxy,
        ApiServiceProxies.ReportsServiceProxy,
        ApiServiceProxies.CredentialsServiceProxy,
        ApiServiceProxies.BankAccountsServiceProxy,
        ApiServiceProxies.CertificatesServiceProxy,
        ApiServiceProxies.EnterpriseServiceProxy,
        ApiServiceProxies.RegionalsServiceProxy,
        ApiServiceProxies.OrdersServiceProxy,
        ApiServiceProxies.ProgrammingsServiceProxy,
        ApiServiceProxies.ActivityTypesServiceProxy,
        ApiServiceProxies.ThematicAreasServiceProxy,
        ApiServiceProxies.ActivitiesServiceProxy,
        ApiServiceProxies.ActivityTemplatesServiceProxy,
        ApiServiceProxies.InvitationsServiceProxy,
        ApiServiceProxies.CalendarsServiceProxy,
        ApiServiceProxies.GuestsServiceProxy,
        ApiServiceProxies.SurveysServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxy.module.ts